import styled from 'styled-components';
import { rems } from 'fe-appdir-lib-theme';

const AppCardFocusedCategory = styled.h4`
  margin: 12px 0 0;
  font-size: ${rems(12)};
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2em;
`;

AppCardFocusedCategory.displayName = 'AppCardFocusedCategory';

export { AppCardFocusedCategory };
